import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Useful for show a loading animation from components like a list, grid, group of buttons, and pills
 * @usage
 * <rx-skeleton-grid
 *   [numberOfItems]="12"
 *   [numberOfColumns]="3"
 *   [rowGap]="1rem"
 *   [columnGap]="1rem"
 *   [itemHeight]="40px"
 * />
 *
 * @example It will create a grid layout like:
 * [Box] [Box] [Box]
 * [Box] [Box] [Box]
 * [Box] [Box] [Box]
 * [Box] [Box] [Box]
 *
 * @param numberOfItems - The number of skeleton boxes to display in the grid
 * @param numberOfColumns - The number of columns in the grid
 * @param rowGap - The gap between rows
 * @param columnGap - The gap between columns in pixels
 * @param itemHeight - The height of each skeleton box
 * @param testId - The test id for automation tests
 */
@Component({
  standalone: true,
  selector: 'rx-skeleton-grid',
  imports: [CommonModule],
  styleUrls: ['./skeleton-grid.component.scss'],
  templateUrl: './skeleton-grid.component.html',
})
export class SkeletonGridComponent {
  @Input() numberOfItems: number = 6;
  @Input() numberOfColumns: number = 2;
  @Input() rowGap: string = '1rem';
  @Input() columnGap: string = '1rem';
  @Input() testId: string = 'test-skeleton-grid';
  @Input() itemHeight: string = '100px';

  get gridStyle(): Record<string, string> {
    return {
      gap: `${this.rowGap} ${this.columnGap}`,
      'grid-template-columns': `repeat(${this.numberOfColumns}, 1fr)`,
    };
  }

  get arrayOfItems() {
    return Array.from({ length: this.numberOfItems });
  }
}
